import dayjs from 'dayjs';

export const getStartOfCurrentFiscalYear = (firstDayOfFiscalYear?: Date | string | null) => {
  const today = dayjs();
  const fallbackStart = today.startOf('year').utc();

  if (firstDayOfFiscalYear == null) {
    return fallbackStart;
  }

  const parsed = dayjs(firstDayOfFiscalYear);
  if (!parsed.isValid()) {
    return fallbackStart;
  }

  const fiscalYearStartForCurrentYear = parsed.utc().year(today.year());
  if (!fiscalYearStartForCurrentYear.isValid()) {
    return fallbackStart;
  }

  const currentDate = today.utc();

  return currentDate < fiscalYearStartForCurrentYear
    ? fiscalYearStartForCurrentYear.subtract(1, 'year')
    : fiscalYearStartForCurrentYear;
};
